const TagList = [{
    id: 't1',
    cont: '장거리',
    value: '1',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
},{
    id: 't2',
    cont: '서운함',
    value: '2',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
},{
    id: 't3',
    cont: '바람',
    value: '3',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
},{
    id: 't4',
    cont: '차단',
    value: '4',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
},{
    id: 't5',
    cont: '집착',
    value: '5',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
},{
    id: 't6',
    cont: '재회',
    value: '6',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
},{
    id: 't7',
    cont: '권태',
    value: '7',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
},{
    id: 't8',
    cont: '회피',
    value: '8',
    color: '#767676',
    background: '#F1F1F1',
    checked: false
}];

export default TagList;